import fetchGuideData from "./fetchGuideData";
const GUIDES_KEY = 'veer-theme-certified-guides-cache-v1';

const parseData = data => {
  const r = data.match(/google\.visualization\.Query\.setResponse\(([\s\S\w]+)\)/);
  const obj = JSON.parse(r[1]);

  const table = obj.table;
  const header = table.cols.map(({ label }) => label);
  const rows = table.rows.map(({ c }) => c.map((row) => row?.v || null));

  return rows.map(row => Object.fromEntries(row.map((value, i) => ([header[i], value])))).filter(row => row["Show guide on PDP"] === "Y");
}

const saveGuides = (data) => {
  try {
    window.localStorage.setItem(GUIDES_KEY, JSON.stringify(data));
  } catch (error) {
    console.warn(error);
  }
};

const getGuides = () => {
  try {
    return JSON.parse(window.localStorage.getItem(GUIDES_KEY));
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export default async function getGuideData(currentHash) {
  const guideData = getGuides();

  if (guideData && guideData.hash === currentHash) {
    return guideData.data;
  }

  const { hash, rawData } = await fetchGuideData();

  const newData = parseData(JSON.parse(rawData).raw);

  saveGuides({
    hash,
    data: newData,
  });

  return newData;
}
